var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn-red-secondary",on:{"click":_vm.handleClick}},[_c('p',{staticClass:"averta-bold"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }